import api from './api';
import config from '../utils/config';

export const authService = {
  login: async (email, password) => {
    try {
      const response = await api.post('/auth/login.php', { email, password });
      
      if (response.data.success) {
        localStorage.setItem(config.TOKEN_KEY, response.data.data.token);
        localStorage.setItem(config.USER_KEY, JSON.stringify(response.data.data.user));
      }
      
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Login failed' };
    }
  },

  logout: async () => {
    try {
      await api.post('/auth/logout.php');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Clear all stored data
      localStorage.removeItem(config.TOKEN_KEY);
      localStorage.removeItem(config.USER_KEY);
      sessionStorage.clear();
      
      // Force redirect to login
      window.location.replace('/login');
    }
  },

  getCurrentUser: () => {
    const userData = localStorage.getItem(config.USER_KEY);
    return userData ? JSON.parse(userData) : null;
  },

  isAuthenticated: () => {
    return !!localStorage.getItem(config.TOKEN_KEY);
  },

  isAdmin: () => {
    const user = authService.getCurrentUser();
    return user && user.role === 'Admin';
  },
};

export default authService;
